import accordion from '@primevue/themes/material/accordion';
import autocomplete from '@primevue/themes/material/autocomplete';
import avatar from '@primevue/themes/material/avatar';
import badge from '@primevue/themes/material/badge';
import base from '@primevue/themes/material/base';
import blockui from '@primevue/themes/material/blockui';
import breadcrumb from '@primevue/themes/material/breadcrumb';
import button from '@primevue/themes/material/button';
import card from '@primevue/themes/material/card';
import carousel from '@primevue/themes/material/carousel';
import cascadeselect from '@primevue/themes/material/cascadeselect';
import checkbox from '@primevue/themes/material/checkbox';
import chip from '@primevue/themes/material/chip';
import colorpicker from '@primevue/themes/material/colorpicker';
import confirmdialog from '@primevue/themes/material/confirmdialog';
import confirmpopup from '@primevue/themes/material/confirmpopup';
import contextmenu from '@primevue/themes/material/contextmenu';
import datatable from '@primevue/themes/material/datatable';
import dataview from '@primevue/themes/material/dataview';
import datepicker from '@primevue/themes/material/datepicker';
import dialog from '@primevue/themes/material/dialog';
import divider from '@primevue/themes/material/divider';
import dock from '@primevue/themes/material/dock';
import drawer from '@primevue/themes/material/drawer';
import editor from '@primevue/themes/material/editor';
import fieldset from '@primevue/themes/material/fieldset';
import fileupload from '@primevue/themes/material/fileupload';
import floatlabel from '@primevue/themes/material/floatlabel';
import galleria from '@primevue/themes/material/galleria';
import iconfield from '@primevue/themes/material/iconfield';
import iftalabel from '@primevue/themes/material/iftalabel';
import image from '@primevue/themes/material/image';
import imagecompare from '@primevue/themes/material/imagecompare';
import inlinemessage from '@primevue/themes/material/inlinemessage';
import inplace from '@primevue/themes/material/inplace';
import inputchips from '@primevue/themes/material/inputchips';
import inputgroup from '@primevue/themes/material/inputgroup';
import inputnumber from '@primevue/themes/material/inputnumber';
import inputotp from '@primevue/themes/material/inputotp';
import inputtext from '@primevue/themes/material/inputtext';
import knob from '@primevue/themes/material/knob';
import listbox from '@primevue/themes/material/listbox';
import megamenu from '@primevue/themes/material/megamenu';
import menu from '@primevue/themes/material/menu';
import menubar from '@primevue/themes/material/menubar';
import message from '@primevue/themes/material/message';
import metergroup from '@primevue/themes/material/metergroup';
import multiselect from '@primevue/themes/material/multiselect';
import orderlist from '@primevue/themes/material/orderlist';
import organizationchart from '@primevue/themes/material/organizationchart';
import overlaybadge from '@primevue/themes/material/overlaybadge';
import paginator from '@primevue/themes/material/paginator';
import panel from '@primevue/themes/material/panel';
import panelmenu from '@primevue/themes/material/panelmenu';
import password from '@primevue/themes/material/password';
import picklist from '@primevue/themes/material/picklist';
import popover from '@primevue/themes/material/popover';
import progressbar from '@primevue/themes/material/progressbar';
import progressspinner from '@primevue/themes/material/progressspinner';
import radiobutton from '@primevue/themes/material/radiobutton';
import rating from '@primevue/themes/material/rating';
import ripple from '@primevue/themes/material/ripple';
import scrollpanel from '@primevue/themes/material/scrollpanel';
import select from '@primevue/themes/material/select';
import selectbutton from '@primevue/themes/material/selectbutton';
import skeleton from '@primevue/themes/material/skeleton';
import slider from '@primevue/themes/material/slider';
import speeddial from '@primevue/themes/material/speeddial';
import splitbutton from '@primevue/themes/material/splitbutton';
import splitter from '@primevue/themes/material/splitter';
import stepper from '@primevue/themes/material/stepper';
import steps from '@primevue/themes/material/steps';
import tabmenu from '@primevue/themes/material/tabmenu';
import tabs from '@primevue/themes/material/tabs';
import tabview from '@primevue/themes/material/tabview';
import tag from '@primevue/themes/material/tag';
import terminal from '@primevue/themes/material/terminal';
import textarea from '@primevue/themes/material/textarea';
import tieredmenu from '@primevue/themes/material/tieredmenu';
import timeline from '@primevue/themes/material/timeline';
import toast from '@primevue/themes/material/toast';
import togglebutton from '@primevue/themes/material/togglebutton';
import toggleswitch from '@primevue/themes/material/toggleswitch';
import toolbar from '@primevue/themes/material/toolbar';
import tooltip from '@primevue/themes/material/tooltip';
import tree from '@primevue/themes/material/tree';
import treeselect from '@primevue/themes/material/treeselect';
import treetable from '@primevue/themes/material/treetable';
import virtualscroller from '@primevue/themes/material/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        virtualscroller
    },
    directives: {
        tooltip,
        ripple
    },
    css: ({ dt }) => `

    `
};
